import { FC, useMemo } from 'react';

import { AiOutlineRight } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { MailIcon, SMSIcon } from 'ui/components/icon';
import { MFA_METHOD } from 'utils/constants';
import { cn } from 'utils/helpers';

import { useLoginContext } from '../containers/login/Login';

interface PROPS {
  disabled: boolean;
  onSubmit: (payload: { method: MFA_METHOD }) => void;
}

const LoginNominationForm: FC<PROPS> = ({ disabled, onSubmit }) => {
  const navigate = useNavigate();
  const { mfa } = useLoginContext();

  const emailAddress = useMemo(() => {
    if (mfa?.emailAddress) {
      const { pref, suff, client } = mfa.emailAddress;

      return `${pref}***${suff}@${client}`;
    }

    return null;
  }, [mfa?.emailAddress]);

  const recoveryMobileNumber = useMemo(() => {
    if (mfa?.recoveryMobileNumber) {
      const { pref, suff } = mfa.recoveryMobileNumber;

      return `${pref}***${suff}`;
    }

    return null;
  }, [mfa?.recoveryMobileNumber]);

  return (
    <div className="space-y-6 mt-10">
      {mfa?.recoveryMobileNumber && (
        <button
          disabled={disabled}
          onClick={() => onSubmit({ method: MFA_METHOD.SMS })}
          type="button"
          className={cn(
            'text-left mx-auto p-4',
            'bg-fill-primary rounded-[6px]',
            'border border-separator-primary',
            'flex justify-between items-center',
            'w-full max-w-[426px]',
          )}
        >
          <div className="flex gap-4">
            <SMSIcon className="w-[56px] h-[56px] text-primary-base" />
            <div className="flex flex-col justify-center space-y-2">
              <p className="text-sm">Text a Code</p>
              <p className="text-sm">{recoveryMobileNumber}</p>
            </div>
          </div>
          <AiOutlineRight className="w-6 h-6 text-content" />
        </button>
      )}
      {mfa?.emailAddress && (
        <button
          disabled={disabled}
          onClick={() => onSubmit({ method: MFA_METHOD.EMAIL })}
          type="button"
          className={cn(
            'text-left mx-auto p-4',
            'bg-fill-primary rounded-[6px]',
            'border border-separator-primary',
            'flex justify-between items-center',
            'w-full max-w-[426px]',
          )}
        >
          <div className="flex gap-4">
            <MailIcon className="w-[56px] h-[56px] text-primary-base" />
            <div className="flex flex-col justify-center space-y-2">
              <p className="text-sm">Email a code</p>
              <p className="text-sm">{emailAddress}</p>
            </div>
          </div>
          <AiOutlineRight className="w-6 h-6 text-content" />
        </button>
      )}
      <p className="text-sm">
        Don't have access to both?{' '}
        <a href="/" className="text-info-base font-bold text-sm">
          Contact Support
        </a>
      </p>
      <Button
        intent="text"
        className="text-disabled mx-auto"
        onClick={() => navigate('/logout')}
        label="Back to Login"
      />
    </div>
  );
};

export default LoginNominationForm;
